import { render, staticRenderFns } from "./editClassSet.vue?vue&type=template&id=96aa2584&"
import script from "./editClassSet.vue?vue&type=script&lang=js&"
export * from "./editClassSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports